// app/page.tsx
import { SignInButton, SignOutButton, UserButton } from '@clerk/nextjs';

const HomePage = () => {
    return (
        <div>
            <h1>Sail the Boat Game</h1>
            {/* This UserButton automatically handles rendering for logged-in users */}
            <UserButton />
            {/* These buttons will handle sign in and sign out */}
            <SignInButton />
            <SignOutButton />
        </div>
    );
};

export default HomePage;